<template>
  <section>
    <section v-if="article" class="tw-relative tw-my-8 md:tw-px-32">
      <button class="tw-absolute tw-flex tw-items-center tw-top-0 tw-start-0 -tw-translate-y-12 md:tw-translate-y-0" @click="onBack">
        <SvgoCommonArrowWhite class="tw-mr-2 tw-w-4 tw-h-4 tw-rotate-180" />
        <span class="tw-text-xl tw-font-semibold tw-tracking-normal tw-text-[#1f1f1f]">BACK</span>
      </button>
      <NuxtImg :src="imgSrc" class="tw-rounded-[16px] tw-object-cover tw-w-full" />

      <section class="tw-flex tw-justify-between tw-mt-2 md:tw-mt-4">
        <div>
          <p class="tw-flex tw-flex-wrap tw-mb-2 tw-leading-7 md:tw-leading-10">
            <template v-if="Array.isArray(article.category)">
              <span
                class="tw-bg-primary tw-font-semibold tw-text-sm tw-rounded-[6px] tw-inline-flex tw-leading-7 tw-self-center tw-px-3 tw-mr-2 md:tw-text-lg md:tw-leading-8"
                v-for="item in article.category"
              >
                {{ typeof item === 'string' ? item : item.$.term }}
              </span>
            </template>
            <span class="tw-text-neutral-400 tw-ml-2 tw-grow tw-justify-end tw-inline-flex only:tw-ml-0 md:tw-grow-0 md:tw-justify-start">{{
              localDate
            }}</span>
          </p>
        </div>
        <div class="tw-hidden lg:tw-flex">
          <p class="tw-flex tw-items-center tw-justify-end tw-leading-10">
            <span class="tw-text-xl/loose tw-mr-4 tw-inline-flex">SHARE THIS</span>
            <a :href="shareLinkedin.shareUrl" target="_blank">
              <div class="tw-w-8 tw-h-8 tw-mr-2 tw-bg-primary tw-text-white tw-flex tw-justify-center tw-items-center tw-rounded-full">
                <SvgoMenuLinkedIn class="tw-fill-current tw-w-4 tw-h-4" />
              </div>
            </a>
            <a :href="shareX.shareUrl" target="_blank">
              <div class="tw-w-8 tw-h-8 tw-bg-primary tw-text-white tw-flex tw-justify-center tw-items-center tw-rounded-full">
                <SvgoMenuX class="tw-fill-current tw-w-4 tw-h-4" />
              </div>
            </a>
          </p>
        </div>
      </section>

      <section class="tw-flex">
        <h1
          class="tw-text-[28px] tw-leading-[1.29] xl:tw-text-[45px] xl:tw-leading-[1.33] tw-font-bold tw-text-dark tw-mt-2 tw-mb-2 md:tw-text-5xl md:tw-mt-6 md:tw-mb-10"
          :data-source="article.source"
        >
          {{ article.title }}
        </h1>
      </section>

      <section class="tw-flex article-container tw-text-dark">
        <ContentRenderer
          :value="article"
          class="tw-prose lg:tw-prose-lg hover:prose-a:tw-text-primary prose-a:tw-decoration-dotted tw-max-w-none tw-underline-offset-4 prose-img:tw-mx-auto prose-img:tw-rounded-[16px]"
        ></ContentRenderer>
      </section>

      <section class="tw-flex tw-flex-col tw-text-[#CECED0] tw-italic tw-mt-8">
        <strong class="tw-me-2">Original source:</strong>
        <!-- <br v-if="showMobileLayout" /> -->
        <NuxtLink class="tw-break-all tw-underline tw-underline-offset-2 hover:tw-text-primary" target="_blank" :to="article.source">
          {{ article.source }}
        </NuxtLink>
      </section>

      <section class="tw-flex tw-items-center tw-justify-center tw-mt-8 lg:tw-hidden">
        <p class="tw-flex tw-items-center tw-justify-center tw-leading-10">
          <span class="tw-text-xl/loose tw-mr-4 tw-inline-flex">SHARE THIS</span>
          <a :href="shareLinkedin.shareUrl" target="_blank">
            <div class="tw-w-8 tw-h-8 tw-mr-2 tw-bg-primary tw-text-white tw-flex tw-justify-center tw-items-center tw-rounded-full">
              <SvgoMenuLinkedIn class="tw-fill-current tw-w-4 tw-h-4" />
            </div>
          </a>
          <a :href="shareX.shareUrl" target="_blank">
            <div class="tw-w-8 tw-h-8 tw-bg-primary tw-text-white tw-flex tw-justify-center tw-items-center tw-rounded-full">
              <SvgoMenuX class="tw-fill-current tw-w-4 tw-h-4" />
            </div>
          </a>
        </p>
      </section>

      <section class="tw-flex tw-flex-col tw-mt-24 lg:tw-hidden">
        <div class="tw-border tw-border-primary tw-rounded-[20px] tw-text-center tw-px-12 tw-py-6">
          <p class="tw-font-semibold tw-text-xl tw-leading-loose">Media Enquiries</p>
          <a
            class="tw-text-lg tw-text-primary tw-leading-loose tw-underline tw-underline-offset-2 hover:tw-text-black"
            :href="`mailto:${email}`"
          >
            {{ email }}
          </a>
        </div>
        <div class="tw-text-center tw-mt-8">
          <p class="tw-text-xl tw-text-primary tw-mb-8">FOLLOW US</p>
          <p class="tw-flex tw-justify-center tw-gap-x-4">
            <a href="https://www.linkedin.com/company/legend-trading" target="_blank">
              <button class="tw-w-16 tw-h-16 tw-rounded-full tw-bg-black tw-text-white tw-flex tw-justify-center tw-items-center">
                <SvgoMenuLinkedIn class="tw-fill-current tw-w-8 tw-h-8" />
              </button>
            </a>
            <a href="https://x.com/LegendOTC" target="_blank">
              <button class="tw-w-16 tw-h-16 tw-rounded-full tw-bg-black tw-text-white tw-flex tw-justify-center tw-items-center">
                <SvgoMenuX class="tw-fill-current tw-w-8 tw-h-8" />
              </button>
            </a>
          </p>
        </div>
      </section>
      <section class="tw-hidden lg:tw-flex tw-justify-between tw-mt-12">
        <div>
          <p class="tw-text-xl tw-text-primary tw-mb-8">FOLLOW US</p>
          <p class="tw-flex tw-gap-x-4">
            <a href="https://www.linkedin.com/company/legend-trading" target="_blank">
              <button class="tw-w-16 tw-h-16 tw-rounded-full tw-bg-black tw-text-white tw-flex tw-justify-center tw-items-center">
                <SvgoMenuLinkedIn class="tw-fill-current tw-w-8 tw-h-8" />
              </button>
            </a>
            <a href="https://x.com/LegendOTC" target="_blank">
              <button class="tw-w-16 tw-h-16 tw-rounded-full tw-bg-black tw-text-white tw-flex tw-justify-center tw-items-center">
                <SvgoMenuX class="tw-fill-current tw-w-8 tw-h-8" />
              </button>
            </a>
          </p>
        </div>
        <div>
          <div class="tw-border tw-border-primary tw-rounded-md tw-text-center tw-px-12 tw-py-6">
            <p class="tw-font-semibold tw-text-xl tw-leading-loose">Media Enquiries</p>
            <a
              class="tw-text-lg tw-text-primary tw-leading-loose tw-underline tw-underline-offset-2 hover:tw-text-black"
              :href="`mailto:${email}`"
            >
              {{ email }}
            </a>
          </div>
        </div>
      </section>
    </section>

    <div class="dashed-line tw-mt-20"></div>

    <h2 class="tw-text-center tw-font-bold tw-text-[2.5rem] tw-my-14 md:tw-text-left md:tw-text-5xl">Related News</h2>
    <RepostRelative class="tw-mb-24" :limit="3" :surround="path" @view-article="$emit('view-article', $event)" />
  </section>
</template>

<script setup lang="ts">
  defineProps(['email'])

  const route = useRoute()

  const path = computed(() => {
    if (Array.isArray(route.params.slug)) {
      return `/articles/repost/${route.params.slug.join('/')}`
    } else {
      return `/articles/repost/${route.params.slug}`
    }
  })

  const { data: article } = await useAsyncData('article-data', () =>
    queryContent('articles', 'repost')
      .where({
        _path: path.value,
      })
      .findOne(),
  )

  const imgSrc = computed(() => {
    if (typeof article.value?.image === 'string') {
      return article.value?.image
    } else {
      return article.value?.image?.src
    }
  })

  const localDate = computed(() => {
    const date = new Date(article.value?.date)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  })

  const onBack = async () => {
    await navigateTo({
      name: 'newsroom___en___default',
    })
  }

  const { public: { shareBaseUrl } } = useRuntimeConfig()

  const shareX = useSocialShare({ network: 'x', url: `${shareBaseUrl}${route.fullPath}` })
  const shareLinkedin = useSocialShare({ network: 'linkedin', url: `${shareBaseUrl}${route.fullPath}` })

  watchEffect(() => {
    if (article.value) {
      useContentHead(article.value)
    }
  })

  useHead({
    base: { target: '_blank' },
  })
</script>

<style scoped lang="scss">
  .dashed-line {
    height: 2px;
    background: linear-gradient(to right, transparent 50%, #ffffff 50%),
      linear-gradient(
        to right,
        rgba(224, 224, 224, 0) 5%,
        rgba(224, 224, 224, 0.9) 25%,
        rgba(224, 224, 224, 0.9) 75%,
        rgba(224, 224, 224, 0) 95%
      );
    background-size: 18px 2px, 100% 2px;
  }
</style>
